export function getConcatString(srcObject, seperator) {
    return (srcObject instanceof Array) ? srcObject.join(seperator) : srcObject;
}
